//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UseSegmentContextInReRenderedSubmitSuccessModal: FeatureFlag = {"Id":"UseSegmentContextInReRenderedSubmitSuccessModal","Label":"(KILL)[10.27]UseSegmentContextInReRenderedSubmitSuccessModal","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. When active, re-rendering the submit success modal on page load (for an already-completed submission) scopes its receipt contents/view types/documents to the just-completed workflow segment. When killed, it scopes to no segment (null), which can show receipt/document content from the wrong segment.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
